@use "../../../globals/bcp";

.m-table {
  margin: 0;

  th,
  td {
    font-weight: 400;
    height: 3rem;
    line-height: 0.9rem;
    box-sizing: border-box;
    padding: 0.75rem 1rem;
    border-width: 0 0 0.06rem;
    border-style: solid;
    border-color: bcp.colorVar("link-disabled");
    white-space: nowrap;
  }

  thead {
    th {
      background: transparent;
    }
  }

  & tbody tr {
    td {
      font-weight: 600;
    }
  }
}

.m-popover :last-child {
  margin: 0 auto;
}
